/**
 * AUTO 入口两个端点都失败时,决定报哪一个错。
 *
 * 用户名登录(非邮箱/手机号)先试平台 `/auth/login`,再试租户 `/auth/tenant/login`。
 * 租户账号在平台端必然是「用户名或密码错误」—— 以前一律抛首选端点的错,于是租户侧
 * 已经校验过密码才给出的具体原因(「账号已停用」「租户不存在或已停用」等)永远被这句
 * 笼统的话盖住(0926 旅程冒烟第 10 步抓到)。
 *
 * 规则:首选的错是笼统的「凭证不对」、而后备端点给出了别的说法 → 报后备的;否则报首选的。
 * 两边都是笼统的那句时报首选的,不泄露账号在哪个端点存在。
 */
export const GENERIC_CREDENTIAL_ERROR = "用户名或密码错误";

function messageOf(e: unknown): string {
  return e instanceof Error ? e.message : String(e ?? "");
}

export function isGenericCredentialError(e: unknown): boolean {
  return messageOf(e).trim() === GENERIC_CREDENTIAL_ERROR;
}

export function pickLoginError(primaryErr: unknown, fallbackErr: unknown): unknown {
  if (isGenericCredentialError(primaryErr) && !isGenericCredentialError(fallbackErr)) {
    return fallbackErr;
  }
  return primaryErr;
}
